
export default function Reviews() {
  const reviews = [
    {
      name: '農家の方（50代男性）',
      rating: 5,
      title: '直売所での5%割引が嬉しい',
      content: '毎週農産物直売所で野菜を買うので、5%割引は本当に助かります。年間で考えるとかなりの節約になっています。地元の新鮮な野菜がおトクに買えるのは最高です。',
      date: '2024年10月'
    },
    {
      name: '会社員（40代男性）',
      rating: 5,
      title: 'ガソリン代の節約に',
      content: '通勤で車を使うので、提携給油所での2円引きは地味に効きます。月に50L給油すると100円、年間で1,200円の節約。年会費も条件達成で無料なので、実質プラスです。',
      date: '2024年9月'
    },
    {
      name: '主婦（30代女性）',
      rating: 4,
      title: '提携スーパーでの買い物がおトク',
      content: '近所に提携スーパーがあるので、+2%還元は嬉しいです。提携金融機関の口座開設が必要でしたが、アプリで簡単にできました。地域密着型のサービスが気に入っています。',
      date: '2024年8月'
    },
    {
      name: '自営業（60代男性）',
      rating: 4,
      title: '長年愛用しています',
      content: '地域金融機関との付き合いが長いので、このカードも10年以上使っています。直売所割引やガソリン割引など、地方に住んでいると特典を活かしやすいカードだと思います。',
      date: '2024年7月'
    }
  ];

  const averageRating = (reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length).toFixed(1);

  return (
    <section className="py-16 bg-[#F0FFF4]">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#003366] mb-4 text-center">
          地域密着型クレジットカードの口コミ・評判
        </h2>
        <div className="flex items-center justify-center gap-2 mb-12">
          <div className="flex items-center">
            {[1, 2, 3, 4, 5].map((star) => (
              <i
                key={star}
                className={`ri-star-fill text-xl ${star <= Math.round(Number(averageRating)) ? 'text-[#FFD700]' : 'text-gray-300'} w-5 h-5 flex items-center justify-center`}
              ></i>
            ))}
          </div>
          <span className="text-2xl font-bold text-[#003366]">{averageRating}</span>
          <span className="text-gray-600">/ 5.0</span>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {reviews.map((review, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-6">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-[#00A040]/10 rounded-full flex items-center justify-center">
                    <i className="ri-user-line text-[#00A040] w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <p className="font-medium text-[#003366] text-sm">{review.name}</p>
                    <p className="text-xs text-gray-500">{review.date}</p>
                  </div>
                </div>
                <div className="flex items-center">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i
                      key={star}
                      className={`ri-star-fill text-sm ${star <= review.rating ? 'text-[#FFD700]' : 'text-gray-300'} w-4 h-4 flex items-center justify-center`}
                    ></i>
                  ))}
                </div>
              </div>
              <h3 className="font-bold text-[#003366] mb-2">{review.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{review.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
